<template>
  <div>
    <template v-if="isLoad">
      <template v-if="isMobilePaymentNew()">
        <MobilePayment/>
      </template>
      <template v-else-if="isMobilePaymentEdit()">
        <MobilePaymentEdit/>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";
import Contract from "@/mixins/contract";
import MobilePayment from "@/views/MobilePayment";
import MobilePaymentEdit from "@/views/MobilePaymentEdit";
import { PAYMENT_RESULT_CODE } from "@/constants/constants";
import isMobile from "@/mixins/ismobile";

export default {
  props:{

  },

  data() {
    return {
      isLoad: false,
    };
  },

  mixins: [Loader, Contract, isMobile],
  components: { MobilePayment, MobilePaymentEdit },
  created() {},

  mounted() {
    this.isLoad = false;
    document.getElementById('container').scrollIntoView({
        behavior: 'instant',
        block: 'start'
    });
    this.loading(async () => {
      const ret = await this.checkExpired();
      if (ret) {
        if (this.isMobilePaymentNew()) {
          this.$router.go({ path: "/mobile", force: true });
        }
        else if (this.isMobilePaymentEdit()) {
          this.$router.go({ path: "/mobile-edit", force: true });
        }
      }
      else {
        const acinfo = await this.showAccount(await this.showAccountID());
        if (acinfo) {
          let isRootUser = false;
          const uid = await this.showUserId();
          if (acinfo.root_users && acinfo.root_users.length > 0) {
            isRootUser = acinfo.root_users.includes(uid);
          }
          // ルートユーザ以外はエラーにする
          if (!isRootUser) {
            // 申込不可
            if (this.isMobilePaymentNew()) {
              this.$router.push({ name: "mobile-payment-complete", params:{result: PAYMENT_RESULT_CODE.Retry} });
            }
            else if (this.isMobilePaymentEdit()) {
              this.$router.push({ name: "mobile-payment-edit-complete", params:{result: PAYMENT_RESULT_CODE.Error, message: "このログインユーザではカード変更できません。アカウントを登録したユーザでログインし直してください。" } });
            }
            return;
          }
          if (this.isAccountContractPlan(acinfo)) {
            if (this.isMobilePaymentNew()) {
              this.$router.push({ name: "mobile-payment-complete", params:{result: PAYMENT_RESULT_CODE.Already, message: "有料プランご契約中です。" } });
            }
            else if (this.isMobilePaymentEdit()) {
              // 画面ロード
              this.isLoad = true;
            }
            return;
          }
          else {
            // カード変更時申込が確認できなかったらエラー
            if (this.isMobilePaymentEdit()) {
              // カード変更不可（再申し込みへ誘導する）
              this.$router.push({ name: "mobile-payment-edit-complete", params:{result: PAYMENT_RESULT_CODE.Error, message: "有料プランに申込されておりません。"} });
              return;
            }
            else if (this.isMobilePaymentNew()) {
              // 画面ロード
              this.isLoad = true;
            }
          }
        }
      }
    });
  },

  methods: {
    ...mapActions(["showAccount", "showAccountID", "showCurrentUserInfo", "showUserId"]),

    async checkExpired() {
      const currentUserInfo = await this.showCurrentUserInfo();
      if (currentUserInfo === null || currentUserInfo.username === undefined) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
</style>
